import axios from 'axios'

// ========== 基础配置 ==========
const BASE_URL = 'https://test.nbweiou.cn/api'
const CONTROL_URL = 'https://control.zjwec.cn/api'

// ========== 账户相关 ==========

/** 获取账户名称列表 */
export function findListName() {
  return axios.get(`${BASE_URL}/find_list_name`)
}

/** 根据关键词查询 vivo 用户 */
export function getVivoUser(username) {
  return axios.post(`${BASE_URL}/get_vivo_user`, { username })
}

/** 根据名称查询账户 ID */
export function getByIdsName(idsname) {
  return axios.post(`${BASE_URL}/getByIdsName`, { idsname })
}

// ========== 定向设置 ==========

/** 获取预设定向包列表 */
export function getDirectpkgsList() {
  return axios.get(`${CONTROL_URL}/directpkgs/list`)
}

// ========== 资质查询 ==========

/** 获取广告主资质列表 */
export function getQualificationList({ token, uid, timestamp, nonce }) {
  return axios.post(
    `api/openapi/v1/advertise/qualification/list?access_token=${token}&timestamp=${timestamp}&nonce=${nonce}&advertiser_id=${uid}`,
    {}
  )
}

// ========== 展现形式 ==========

/** 获取转化目标类型列表 */
export function getCvTypeOptions({ token, uid, timestamp, nonce, adType, mediaType, campaignType }) {
  return axios.post(
    `api/openapi/v1/ad/group/cvType/get?access_token=${token}&timestamp=${timestamp}&nonce=${nonce}&advertiser_id=${uid}`,
    {
      adType: parseInt(adType) || 0,
      mediaType: parseInt(mediaType) || 0,
      campaignType: parseInt(campaignType) || 0
    }
  )
}

/** 获取虚拟投放位置列表 */
export function getVirtualPositionList({ token, ids, normId, mediaType, adType, displayType, timestamp, nonce }) {
  return axios.post(
    `api/openapi/v1/ad/positionList/virtualPositionList?access_token=${token}&timestamp=${timestamp}&nonce=${nonce}&advertiser_id=${ids}`,
    {
      normId: parseInt(normId) || 0,
      mediaType: parseInt(mediaType) || 0,
      adType: parseInt(adType) || 0,
      displayType: parseInt(displayType) || 0
    }
  )
}



// WEBPACK FOOTER //
// ./src/components/vivo/vivopda/api.js